import {
    STATS,
    LVL_ID,
    STAT_CATEGORY_ORDER,
} from '../../core/st';
import { normalizeDefenseShare } from '../../core/GenConfig';
import { pickLvlAtOrBelow } from '../../core/spellUtils';
import { buildCardRelevantStatIds } from '../../utils/spellCardStatIds';

export const INFINITY = String.fromCharCode(0x221e);
export const LEVEL_STAT_ICON_SRC = '/img/stat_lvl.png';
export const MAX_AI_CHAT_CARD_SPELLS = 4;
export const AI_CHAT_GENERATION_TIME_LIMIT_FALLBACK = 10;

const TXT = {
    homeTitle: {
        fr: 'Génère le stuff optimal.',
        en: 'Generate the optimal build.',
        de: 'Generiere den optimalen Build.',
        es: 'Genera la build óptima.',
        pt: 'Gere a build ideal.',
    },
    homeHeroSubtitle: {
        fr: 'Sélectionne les stats que tu vises, les sorts que tu veux maximiser et génère le stuff optimal.',
        en: 'Select the stats you want to target, the spells you want to maximize and generate the optimal build.',
        de: 'Wähle die Stats, die du anvisierst, und die Zauber, die du maximieren willst, und generiere den optimalen Build.',
        es: 'Selecciona las stats que buscas, los hechizos que quieres maximizar y genera la build óptima.',
        pt: 'Selecione as stats que você busca, os feitiços que quer maximizar e gere a build ideal.',
    },
    title: {
        fr: 'Assistant AI dofgen',
        en: 'dofgen AI Assistant',
        de: 'dofgen KI-Assistent',
        es: 'Asistente IA dofgen',
        pt: 'Assistente IA dofgen',
    },
    subtitle: {
        fr: 'Décris ton objectif, vérifie les critères proposés, puis lance la génération.',
        en: 'Describe your goal, review the proposed criteria, then run the generation.',
        de: 'Beschreibe dein Ziel, prüfe die vorgeschlagenen Kriterien und starte die Generierung.',
        es: 'Describe tu objetivo, revisa los criterios propuestos y lanza la generación.',
        pt: 'Descreva o seu objetivo, verifique os critérios propostos e inicie a geração.',
    },
    placeholder: {
        fr: 'Demande un stuff ou pose une question à notre IA.',
        en: 'Ask for a build or put a question to our AI.',
        de: 'Frag nach einem Build oder stell unserer KI eine Frage.',
        es: 'Pide una build o hazle una pregunta a nuestra IA.',
        pt: 'Peça uma build ou faça uma pergunta à nossa IA.',
    },
    send: { fr: 'Envoyer', en: 'Send', de: 'Senden', es: 'Enviar', pt: 'Enviar' },
    generate: { fr: 'Générer', en: 'Generate', de: 'Generieren', es: 'Generar', pt: 'Gerar' },
    stop: { fr: 'Arrêter', en: 'Stop', de: 'Stoppen', es: 'Detener', pt: 'Parar' },
    openBuild: { fr: 'Ouvrir le stuff', en: 'Open build', de: 'Build öffnen', es: 'Abrir la build', pt: 'Abrir a build' },
    draftReady: {
        fr: 'Je peux générer le stuff suivant :',
        en: 'I can generate the following build:',
        de: 'Ich kann folgenden Build generieren:',
        es: 'Puedo generar la siguiente build:',
        pt: 'Posso gerar a seguinte build:',
    },
    clarifyFallback: {
        fr: 'Indique une classe, un niveau et les priorités à optimiser.',
        en: 'Give a class, a level and the priorities to optimize.',
        de: 'Gib eine Klasse, eine Stufe und die zu optimierenden Prioritäten an.',
        es: 'Indica una clase, un nivel y las prioridades a optimizar.',
        pt: 'Indique uma classe, um nível e as prioridades a otimizar.',
    },
    chipsTitle: {
        fr: 'Critères traduits',
        en: 'Translated criteria',
        de: 'Übersetzte Kriterien',
        es: 'Criterios traducidos',
        pt: 'Critérios traduzidos',
    },
    level: { fr: 'Niveau', en: 'Level', de: 'Stufe', es: 'Nivel', pt: 'Nível' },
    assumptions: { fr: 'Hypothèses', en: 'Assumptions', de: 'Annahmen', es: 'Hipótesis', pt: 'Hipóteses' },
    warnings: { fr: 'Avertissements', en: 'Warnings', de: 'Warnungen', es: 'Advertencias', pt: 'Avisos' },
    preview: { fr: 'Aperçu', en: 'Preview', de: 'Vorschau', es: 'Vista previa', pt: 'Pré-visualização' },
    noPreview: {
        fr: 'Aucun résultat généré.',
        en: 'No generated result yet.',
        de: 'Noch kein Ergebnis generiert.',
        es: 'Ningún resultado generado.',
        pt: 'Nenhum resultado gerado.',
    },
    opening: { fr: 'Ouverture...', en: 'Opening...', de: 'Wird geöffnet...', es: 'Abriendo...', pt: 'Abrindo...' },
    aiBusy: { fr: 'Interprétation en cours', en: 'Interpreting', de: 'Wird interpretiert', es: 'Interpretando', pt: 'Interpretando' },
    genBusy: { fr: 'Génération en cours...', en: 'Generating...', de: 'Generierung läuft...', es: 'Generando...', pt: 'Gerando...' },
    genStarting: {
        fr: 'Je lance la génération.',
        en: 'Starting generation.',
        de: 'Ich starte die Generierung.',
        es: 'Lanzo la generación.',
        pt: 'Inicio a geração.',
    },
    genQueued: { fr: 'Job en file', en: 'Queued', de: 'Job in Warteschlange', es: 'Trabajo en cola', pt: 'Job na fila' },
    genBooting: { fr: 'Initialisation', en: 'Booting', de: 'Initialisierung', es: 'Inicializando', pt: 'Inicializando' },
    genLoading: { fr: 'Optimisation', en: 'Optimizing', de: 'Optimierung', es: 'Optimizando', pt: 'Otimizando' },
    genDone: { fr: 'Génération terminée', en: 'Generation complete', de: 'Generierung abgeschlossen', es: 'Generación terminada', pt: 'Geração concluída' },
    score: { fr: 'Score', en: 'Score', de: 'Score', es: 'Puntuación', pt: 'Pontuação' },
    genError: { fr: 'Génération en erreur', en: 'Generation failed', de: 'Generierung fehlgeschlagen', es: 'Error en la generación', pt: 'Erro na geração' },
    genStopped: { fr: 'Génération arrêtée.', en: 'Generation stopped', de: 'Generierung gestoppt.', es: 'Generación detenida.', pt: 'Geração interrompida.' },
    msgBuildSaved: { fr: 'Stuff enregistré.', en: 'Build saved.', de: 'Build gespeichert.', es: 'Build guardada.', pt: 'Build salva.' },
    msgClaimStart: {
        fr: 'Connexion Discord requise pour ouvrir ce stuff.',
        en: 'Discord login is required to open this build.',
        de: 'Discord-Anmeldung erforderlich, um diesen Build zu öffnen.',
        es: 'Se requiere iniciar sesión con Discord para abrir esta build.',
        pt: 'É necessário entrar com o Discord para abrir esta build.',
    },
    msgDraftRequired: {
        fr: 'Envoie d\'abord un prompt pour obtenir un draft.',
        en: 'Send a prompt first to create a draft.',
        de: 'Sende zuerst einen Prompt, um einen Entwurf zu erhalten.',
        es: 'Envía primero un prompt para obtener un borrador.',
        pt: 'Envie primeiro um prompt para obter um rascunho.',
    },
    msgGenFailed: {
        fr: 'Génération impossible pour ce draft.',
        en: 'Generation failed for this draft.',
        de: 'Generierung für diesen Entwurf nicht möglich.',
        es: 'Generación imposible para este borrador.',
        pt: 'Geração impossível para este rascunho.',
    },
    msgNoResult: {
        fr: 'Aucun stuff final reçu.',
        en: 'No final build received.',
        de: 'Kein finaler Build empfangen.',
        es: 'No se ha recibido ninguna build final.',
        pt: 'Nenhuma build final recebida.',
    },
    msgAiRateLimited: {
        fr: 'Trop de requêtes IA pour le moment.',
        en: 'Too many AI requests right now.',
        de: 'Momentan zu viele KI-Anfragen.',
        es: 'Demasiadas peticiones de IA por ahora.',
        pt: 'Muitos pedidos de IA no momento.',
    },
    msgGenRateLimited: {
        fr: 'Trop de générations pour le moment.',
        en: 'Too many generation requests right now.',
        de: 'Momentan zu viele Generierungen.',
        es: 'Demasiadas generaciones por ahora.',
        pt: 'Muitas gerações no momento.',
    },
    msgAiUnavailable: {
        fr: 'Service IA indisponible. Réessaie dans un instant.',
        en: 'AI service unavailable. Try again shortly.',
        de: 'KI-Dienst nicht verfügbar. Versuche es gleich erneut.',
        es: 'Servicio de IA no disponible. Inténtalo en un momento.',
        pt: 'Serviço de IA indisponível. Tente novamente em instantes.',
    },
    msgAiInvalid: {
        fr: 'Requête invalide. Réessaie avec plus de détails.',
        en: 'Invalid request. Try again with more detail.',
        de: 'Ungültige Anfrage. Versuche es mit mehr Details.',
        es: 'Petición no válida. Inténtalo con más detalles.',
        pt: 'Pedido inválido. Tente com mais detalhes.',
    },
    resumeConversation: {
        fr: 'Reprendre une conversation',
        en: 'Resume a conversation',
        de: 'Unterhaltung fortsetzen',
        es: 'Retomar una conversación',
        pt: 'Retomar uma conversa',
    },
    homeChatTitle: {
        fr: 'Découvre dofgen avec notre assistant IA',
        en: 'Discover dofgen with our AI assistant',
        de: 'Entdecke dofgen mit unserem KI-Assistenten',
        es: 'Descubre dofgen con nuestro asistente IA',
        pt: 'Descubra o dofgen com o nosso assistente IA',
    },
    back: { fr: 'Retour', en: 'Back', de: 'Zurück', es: 'Volver', pt: 'Voltar' },
    genPromo: {
        fr: 'L\'assistant IA donne uniquement un aperçu du générateur, pour accéder à toutes les fonctionnalités, allez sur la page dédiée.',
        en: 'The AI assistant only gives a preview of the generator; for the full feature set, go to the dedicated page.',
        de: 'Der KI-Assistent zeigt nur einen Ausschnitt des Generators. Für alle Funktionen geh auf die eigene Seite.',
        es: 'El asistente IA solo ofrece una vista previa del generador; para acceder a todas las funciones, ve a la página dedicada.',
        pt: 'O assistente IA dá apenas uma prévia do gerador; para acessar todos os recursos, vá para a página dedicada.',
    },
    genPromoCta: {
        fr: 'Générateur',
        en: 'Generator',
        de: 'Generator',
        es: 'Generador',
        pt: 'Gerador',
    },
    remove: { fr: 'Retirer', en: 'Remove', de: 'Entfernen', es: 'Quitar', pt: 'Remover' },
    statsCriteria: { fr: 'Stats', en: 'Stats', de: 'Stats', es: 'Stats', pt: 'Stats' },
};

export function t(lang, key) {
    return TXT[key]?.[lang] || TXT[key]?.en || key;
}

export function statDefById(id) {
    return STATS.find((row) => Number(row.id) === Number(id)) || null;
}

/** Spell grouping order: 4 mono-elements, then pushback, then anything else. */
export const SPELL_ELEMENT_ORDER = ['earth', 'fire', 'water', 'air', 'push', 'other'];

/**
 * Bucket a spell into an element group and find its unlock level.
 * Dominant elemental damage wins; pure pushback spells go to 'push'; the rest to 'other'.
 */
export function spellGroupInfo(spell, lvl) {
    const levels = Array.isArray(spell?.levels) ? spell.levels : [];
    const lv = pickLvlAtOrBelow(levels, lvl) || levels[0] || null;
    const lines = Array.isArray(lv?.effect_lines) ? lv.effect_lines : [];
    const elemSum = { earth: 0, fire: 0, water: 0, air: 0 };
    let pushSum = 0;
    lines.forEach((ln) => {
        const mag = (Number(ln?.min) || 0) + (Number(ln?.max) || 0);
        if (ln?.type === 'push') { pushSum += mag; return; }
        if (ln?.type === 'damage' && elemSum[ln?.element] !== undefined) elemSum[ln.element] += mag;
    });
    let bucket = 'other';
    let best = 0;
    ['earth', 'fire', 'water', 'air'].forEach((el) => {
        if (elemSum[el] > best) { best = elemSum[el]; bucket = el; }
    });
    if (best === 0 && pushSum > 0) bucket = 'push';
    const unlockLevel = levels.reduce((min, entry) => {
        const v = Number(entry?.level);
        return Number.isFinite(v) && v > 0 ? Math.min(min, v) : min;
    }, Infinity);
    return { bucket, level: Number.isFinite(unlockLevel) ? unlockLevel : 0 };
}

/** Sort spell criteria chips by element group, then by unlock level (stable within ties). */
export function sortSpellChipsByElement(spellChips, spellDataById, lvl) {
    return [...(spellChips || [])]
        .map((row, index) => {
            const spellId = Number(row?.spell_id ?? row?.spellId ?? row?.id);
            const spell = spellDataById?.get?.(spellId);
            const info = spell ? spellGroupInfo(spell, lvl) : { bucket: 'other', level: 0 };
            return { row, index, ...info };
        })
        .sort((a, b) => {
            const ia = SPELL_ELEMENT_ORDER.indexOf(a.bucket);
            const ib = SPELL_ELEMENT_ORDER.indexOf(b.bucket);
            const oa = ia === -1 ? SPELL_ELEMENT_ORDER.length : ia;
            const ob = ib === -1 ? SPELL_ELEMENT_ORDER.length : ib;
            if (oa !== ob) return oa - ob;
            if (a.level !== b.level) return a.level - b.level;
            return a.index - b.index;
        })
        .map((entry) => entry.row);
}

export function summarizeDraftText(_draft, lang) {
    return t(lang, 'draftReady');
}

export function formatNumber(value) {
    const num = Number(value);
    if (!Number.isFinite(num)) return '-';
    return Math.round(num).toLocaleString();
}

export function localizedStatLabel(stat, lang) {
    return stat?.label?.[lang] || stat?.label?.en || stat?.name || '';
}

export function localizedStatAlias(stat, lang) {
    return stat?.alias?.[lang] || stat?.alias?.en || localizedStatLabel(stat, lang);
}

export function statCardLabel(stat, lang, draftLabel = '') {
    if (stat) return localizedStatAlias(stat, lang);
    return draftLabel;
}

export function draftTimeLimit(draft) {
    if (!draft?.req) return AI_CHAT_GENERATION_TIME_LIMIT_FALLBACK;
    const rawOverride = Number(draft.req.time_limit);
    if (Number.isFinite(rawOverride) && rawOverride > 0) return rawOverride;
    return AI_CHAT_GENERATION_TIME_LIMIT_FALLBACK;
}

export function selectedSpellIdsFromBuild(build) {
    const criteria = typeof build?.getMaximizeSpellCriteria === 'function'
        ? build.getMaximizeSpellCriteria()
        : [];
    const ids = [];
    (Array.isArray(criteria) ? criteria : []).forEach((criterion) => {
        const spellId = Number(
            typeof criterion === 'number'
                ? criterion
                : (criterion?.spell_id ?? criterion?.spellId ?? criterion?.id)
        );
        if (Number.isFinite(spellId) && !ids.includes(spellId)) ids.push(spellId);
    });
    return ids;
}

const STAT_CATEGORY_FALLBACK = 'other';

const CATEGORY_SORT_KEYS = [
    ...STAT_CATEGORY_ORDER,
    STAT_CATEGORY_FALLBACK,
];

function statCategory(statId) {
    return statDefById(statId)?.category || STAT_CATEGORY_FALLBACK;
}

function categorySortIndex(category) {
    const idx = CATEGORY_SORT_KEYS.indexOf(category);
    return idx === -1 ? CATEGORY_SORT_KEYS.length : idx;
}

function statOrder(statId) {
    const stat = statDefById(statId);
    return Number(stat?.order ?? 999);
}

function compareStatIds(a, b) {
    const catCmp = categorySortIndex(statCategory(a)) - categorySortIndex(statCategory(b));
    if (catCmp !== 0) return catCmp;
    return statOrder(a) - statOrder(b);
}

/** Split stats into columns of fixed row capacity (fill col 1, then col 2, …). */
export function distributeStatsByColumnCapacity(rows, rowsPerColumn) {
    if (!rows?.length) return [];
    const capacity = Math.max(1, rowsPerColumn);
    const columns = [];
    for (let i = 0; i < rows.length; i += capacity) {
        columns.push(rows.slice(i, i + capacity));
    }
    return columns;
}

export function buildRelevantStatRows(build, draft, lang, options = {}) {
    if (!build) return [];
    const stats = build.getStats?.() || {};
    const defenseShare = normalizeDefenseShare(
        options.defenseShare ?? draft?.req?.defense_share ?? 0
    );
    const statIds = buildCardRelevantStatIds(build, draft, {
        spellData: options.spellData ?? null,
        defenseShare,
        lang,
    });

    return statIds
        .filter((statId) => Number(statId) !== LVL_ID)
        .filter((statId) => {
            const current = Number(stats[Number(statId)]?.current);
            return Number.isFinite(current) && current !== 0;
        })
        .sort(compareStatIds)
        .map((statId) => {
            const stat = statDefById(statId);
            const labels = draft?.draft_metadata?.criteria_labels?.stats || [];
            const draftLabel = labels.find((row) => Number(row.id) === Number(statId))?.label;
            return {
                key: `stat-${statId}`,
                icon: stat?.icon,
                label: statCardLabel(stat, lang, draftLabel),
                value: formatNumber(stats[Number(statId)]?.current),
            };
        })
        .filter((row) => row.label);
}

const CHAT_SITE_LINK_LABELS = {
    fr: [
        ["l'Encyclopédie", 'encyclopedia'],
        ['Encyclopédie', 'encyclopedia'],
        ['Mes stuffs', 'my-builds'],
        ['Générateur', 'gen'],
        ['Communauté', 'community'],
    ],
    en: [
        ['Encyclopedia', 'encyclopedia'],
        ['My builds', 'my-builds'],
        ['Generator', 'gen'],
        ['Community', 'community'],
    ],
    // Same page names the backend injects into the prompt (core/i18n.py
    // PAGE_LABELS), so the model's own wording is what we match here. Forms
    // carrying an article come first — the scan takes the first hit.
    de: [
        ['Enzyklopädie', 'encyclopedia'],
        ['Meine Builds', 'my-builds'],
        ['Generator', 'gen'],
        ['Community', 'community'],
    ],
    es: [
        ['la Enciclopedia', 'encyclopedia'],
        ['Enciclopedia', 'encyclopedia'],
        ['Mis builds', 'my-builds'],
        ['Generador', 'gen'],
        ['Comunidad', 'community'],
    ],
    pt: [
        ['a Enciclopédia', 'encyclopedia'],
        ['Enciclopédia', 'encyclopedia'],
        ['Minhas builds', 'my-builds'],
        ['Gerador', 'gen'],
        ['Comunidade', 'community'],
    ],
};

// CTA directive: [Label](cta:/fr/gen). Internal app paths only — rendered as a
// prominent button.primary.alt by MarkdownMessage rather than an inline link.
const CHAT_CTA_RE = /\[([^\]]+)\]\(cta:(\/[^\s)]+)\)/g;

/**
 * Pull CTA directives out of a model message.
 * Returns the text with the directives removed and a deduped list of {label, to}
 * navigation buttons. Only internal paths (leading "/") are accepted.
 */
export function extractChatCtas(content) {
    if (!content || typeof content !== 'string') return { text: content || '', ctas: [] };
    const ctas = [];
    const seen = new Set();
    const stripped = content.replace(CHAT_CTA_RE, (_match, rawLabel, rawTo) => {
        const label = String(rawLabel || '').trim();
        const to = String(rawTo || '').trim();
        if (label && to.startsWith('/')) {
            const key = `${label}|${to}`;
            if (!seen.has(key)) {
                seen.add(key);
                ctas.push({ label, to });
            }
        }
        return '';
    });
    const text = stripped
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    return { text, ctas };
}

function enrichPlainSegment(text, lang, labels) {
    let out = text;
    for (const [label, segment] of labels) {
        const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp(escaped, 'gi');
        out = out.replace(re, (match) => `[${match}](/${lang}/${segment})`);
    }
    return out;
}

/** Turn plain section names from the model into markdown links when needed. */
export function enrichChatSiteLinks(content, lang = 'fr') {
    if (!content || typeof content !== 'string') return content;
    if (/\]\(\/[a-z]{2}\//.test(content)) return content;

    const labels = CHAT_SITE_LINK_LABELS[lang] || CHAT_SITE_LINK_LABELS.en;
    const parts = content.split(/(\[[^\]]+\]\([^)]+\))/g);
    return parts
        .map((part) => (part.startsWith('[') && part.includes('](') ? part : enrichPlainSegment(part, lang, labels)))
        .join('');
}
